import IProject from "@interfaces/Core/ProjectManager/project";
import useApiCall from "@hooks/Shared/useApiCall";

const useGetProject = (uuid: string) =>
  useApiCall<IProject>({
    url: `/projects/${uuid}`,
  });

export default useGetProject;
